module.exports = __webpack_public_path__ + "img/single-property-1.b937376.jpg";